import {createAction, createActions, handleActions, combineActions} from 'redux-actions';

export const closeVideo = createAction('CLOSE_VIDEO');

export const search = createAction('SEARCH', (q) => ({
  q
}));

let endpoints = {
  'indexBundle': '/api/1/bundle/index/',
  'events': '/api/1/events/',
  'moments': '/api/1/moments/',
  'indexRecords': '/api/1/records/index/',
  'featuredRecords': '/api/1/records/featured/',
  'latestRecords': '/api/1/records/latest/',
  'myEvents': '/api/1/events/my/',
  'myPosts': '/api/1/events/',
  'myMoments': '/api/1/threads/',
  'updatedLives': '/api/1/lives/updated/',
  'newLives': '/api/1/lives/new/',
  'lives': '/api/1/lives/',
  'updatedFeeds': '/api/1/feeds/updates/',
  'headlineLives': '/api/1/lives/headlines/',
  'changeRequests': '/api/1/change-requests/all/',
  'dailyHotSearches': '/api/1/hot-searches/daily/',
  'hotSearches': '/api/1/hot-searches/',
};

export const fetchObjectComments = createAction('FETCH_OBJECTS', (object) => {
  return {
    object: object,
    name: 'objectComments',
    url: `/api/1/comments/for/${object}/`,
  }
});



// export const updateObjects = createAction('UPDATE_OBJECTS', (objects, target) => {
//   return {
//   }
// });

export const updateStore = (reducerName, store) => {
  if (store.pending) {
    return {
      type: `FETCH_${reducerName.toUpperCase()}_SUCCESSED`,
      payload: store.pending,
    }
  }
}

export const fetchLiveThreads = createAction('FETCH_OBJECTS', (liveId, sort) => {
  return {
    name: 'liveThreads',
    url: `/api/1/lives/${liveId}/threads/?limit=80`,
  }
});

export const fetchObjects = createAction('FETCH_OBJECTS', (objects, target, options) => {
  let url = endpoints[objects];

  if (objects === 'objectChangeRequests') {
    url = `/api/1/change-requests/for/?target=${target}`;

  } else if (objects === 'objectComments') {
    url = `/api/1/comments/for/${target}/`;

  } else if (objects === 'communityRecords') {
    url = `/api/1/records/community/`;

  } else if (objects === 'searchRecords') {
    url = `/api/1/search/?q=${encodeURIComponent(target)}`;

  } else if (objects === 'postsSearchRecords') {
    url = `/api/1/search/?type=live,event&q=${encodeURIComponent(target)}`;

  } else if (objects === 'liveSearchRecords') {
    url = `/api/1/search/live/?q=${encodeURIComponent(target)}`;
  }

  let payload = {
    name: objects,
    url,
    context: target,
    ...options,
  };

  return payload;
});

export const clearObjects = (objects) => ({'type': 'CLEAR_' + objects.toUpperCase()});

export const fetchObjectsSilent = (objects, target) => fetchObjects(objects, target, {silent: true});

export const fetchNearbyLives = createAction('FETCH_OBJECTS', (latitude, longitude) => {
  return {
    name: 'nearbyLives',
    url: `api/1/lives/nearby/?latitude=${latitude}&longitude=${longitude}`,
  }
});


export const fetchMoreCommentThreads = createAction('FETCH_MORE_COMMENT_THREADS', (thread, next) => {
  return {
    thread,
    url: next,
  }
});

export const fetchMoreObjects = createAction('FETCH_MORE_OBJECTS', (objects, next, extra) => {
  return {
    name: objects,
    url: next,
    ...extra,
  }
});


export const startLoadingPage = createAction('START_LOADING_PAGE');
export const finishLoadingPage = createAction('FINISH_LOADING_PAGE');

